import type {PriceExtra} from './PriceExtra';
import type {PriceValueType} from './PriceValueType';

export type CommonFinancingPriceAttribute = {
  code: 'financing_price';
  readonly type?: 'financing_price';
  readonly title?: string;
  value: PriceValueType | null;
  readonly defaultValue?: PriceValueType | null;
  readonly displayValue?: PriceValueType | null;
  readonly extra?: PriceExtra;
  readonly required?: boolean;
  override: boolean;
  readonly hasPublishControl?: boolean;
  publish: boolean;
};
